// @core/api/endpoints/chat/forward_messages.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ForwardMessagesRequest,
  ForwardMessagesResponse,
} from '../../../types/chat';

const BASE_PATH = '/chat';

/**
 * Forward messages
 * Forwards one or more messages from the source conversation to one or more target conversations. Each forward creates a content copy with provenance metadata in the target.
 */
export async function ForwardMessages(
  conversation_id: string,
  data: ForwardMessagesRequest,
  options?: RequestOptions
): Promise<ForwardMessagesResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/conversations/:conversation_id/messages/forward`;
  requestPath = requestPath.replace(':conversation_id', encodeURIComponent(conversation_id));
  const requestOptions = options;
  return client.post<ForwardMessagesResponse>(requestPath, data, requestOptions);
}
